const EVENT_KEY = 'AuwScrollTo';

// Offset Settings
const defaultOffset = 50;
const additionalOffset = 80;
const $mobileHeader = $('.mobile-header');

// check header height and add additional offset. If there is no header height take the default offset
function getHeaderHeight() {
  const height = $mobileHeader.height() || defaultOffset;
  return -(height + additionalOffset);
}

class ScrollManager {

  constructor() {
    this.initialHash = location.hash;

    $(document).ready(this.whenPageLoaded.bind(this))
  }

  whenPageLoaded() {
    if (this.initialHash) {
      const target = this.validateHash(this.initialHash);
      this.makeEventAndPossiblyScrollTo(target);
    }
  }

  /**
   * Check if a given `hash` is present on the current Page. If so, the element you are looking for will be returned. Otherwise, false.
   * @param hash
   */
  validateHash(hash) {
    const targetElement = $(hash).get(0);


    if (targetElement) {
      if(hash.startsWith("#panel") || hash.startsWith("#collapse")){
          $('a[href^="'+hash+'"]').trigger("click");
      }
      return targetElement;
    } else {
      return false;
    }

  }

  makeEventAndPossiblyScrollTo(element) {
    const ev = this.createEvent(element);
    this.dispatchEvent(ev, element);
  }

  createEvent(detail) {
    return new CustomEvent(EVENT_KEY, {
      detail: detail
    });
  }

  dispatchEvent(eventToDispatch, target) {
    const isSuccess = window.dispatchEvent(eventToDispatch);
    this.handleEventResult(!isSuccess, target);
  }

  handleEventResult(gotCanceled, target) {
    if (gotCanceled) {
      console.info('Cannot scroll to target element, event canceled.');
      return;
    } else {
      var scrollToElement = $(target)[0];
      if(scrollToElement) {
        if ($('html').hasClass("browser-safari")) {
          var scrollToHeight = $(scrollToElement).offset().top - defaultOffset;
        } else {
          var scrollToHeight = $(scrollToElement).offset().top - defaultOffset;
        }
        $('html,body').animate({scrollTop: scrollToHeight}, 'fast');
      }
    }
  }


  scrollTo(element) {
    const targetOffset = $(element).offset();
    $('html,body').animate({scrollTop: (targetOffset.top + getHeaderHeight())}, 'fast');
  }
}

window.ScrollManager = new ScrollManager();

